import { defineMessages } from 'react-intl';

export default defineMessages({
  addToCartString: {
    id: 'addToCart',
    description: 'add to cart',
    defaultMessage: 'Add to cart',
  },
});
